import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import { ChevronRightIcon } from '../../common/icons'
import ExternalLink from '../../common/external-link'

export const Container = styled.section`
    padding: 0.5rem 0;
    width: 100%;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1rem 0;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex-direction: row;
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const RegionsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        padding: 1rem 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-top: 1rem;
        gap: 1.5rem;
        padding: 0;
    }
`

export const RegionsColumnCard = styled.div`
    border: 0.063rem solid #d3d3d3;
    border-radius: 0.5rem;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0.5rem 0;
    }
`

export const RegionRow = styled.div<{ $isLast?: boolean; $forceBorder?: boolean }>`
    position: relative;
    display: flex;
    align-items: flex-start;
    padding: 0.875rem 1.25rem;
    min-height: 4.375rem;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0.875rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.875rem 1.25rem;
    }

    ${({ $isLast, $forceBorder, theme }) =>
        (!$isLast || $forceBorder) &&
        css`
            &::after {
                content: '';
                position: absolute;
                left: 1rem;
                right: 1rem;
                bottom: 0;
                border-bottom: 0.063rem dotted ${theme.colors.tfwBlackOpacity10};
            }
        `};

    &:hover {
        background: ${({ theme }) => theme.colors.tfwBlack3};
    }
`

export const RegionOverlayLink = styled(ExternalLink)`
    position: absolute;
    inset: 0;
    z-index: 1;
`

export const LinkWrapper = styled.div`
    text-decoration: none;
    width: 100%;
    display: flex;
    position: relative;
    z-index: 2;
`

export const RegionTexts = styled.div`
    flex: 1;
    min-width: 0;
`

export const RegionTitle = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.4;
        margin: 0 0 0.25rem 0;
        color: ${theme.colors.tfwBlack87};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.0625rem;
        }
    `,
)

export const RegionSubtitle = styled.p`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: #5f5f5f;
    margin: 0;

    a {
        color: inherit;
        text-decoration: none;
    }
    a:hover {
        text-decoration: underline;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 0.875rem;
    }
`

export const ArrowIcon = styled(ChevronRightIcon)`
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1rem;
    min-height: 1rem;
    margin-left: 1rem;
    color: #a5a5a5;
    path {
        stroke: #f6f6f6 !important;
    }
`
